export default __webpack_public_path__ + "static/media/precess2.530352cb.png";